export default __webpack_public_path__ + "static/media/service--application-mobile.48f58932.webp";